import { render, staticRenderFns } from "./copy-field-row.vue?vue&type=template&id=46058560&scoped=true&"
import script from "./copy-field-row.vue?vue&type=script&lang=js&"
export * from "./copy-field-row.vue?vue&type=script&lang=js&"
import style0 from "./copy-field-row.vue?vue&type=style&index=0&id=46058560&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46058560",
  null
  
)

export default component.exports